import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { logAssert } from "@faire/web--source/common/logging";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { ShakeAnimation } from "@faire/web--source/ui/Shakeable";
import React, { Suspense, useContext, useState } from "react";
import styled, { css } from "styled-components";
import { TrackedLinkContext } from "@faire/retailer/components/TrackedLink";
import { useCartProductAddOptions } from "@faire/retailer/features/ProductAdd/useCartProductAddOptions";
import { LazyQuickAddModal } from "@faire/retailer/features/ProductQuickAddModal/LazyQuickAddModal";
import { useCartItems } from "@faire/retailer/hooks/cart/useCartItems";
import { useCartUpdate } from "@faire/retailer/hooks/cart/useCartUpdate";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { canAddToCart } from "@faire/retailer/lib/canAddToCart";
import { ICartItemForUpdate } from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";
import { AddToCartVariants } from "@faire/retailer-visitor-shared/stores/domain/CartStore/triggerAddToCartEvent";
export var QuickAdd = function(param) {
    var productToken = param.productToken, brandToken = param.brandToken, quickAddData = param.quickAddData, onChooseOption = param.onChooseOption, onQuickAddOption = param.onQuickAddOption, onModalClose = param.onModalClose, style = param.style, className = param.className, forceShowModal = param.forceShowModal, productAddOptions = param.productAddOptions, button = param.button, updateCartFn = param.updateCartFn;
    var _useState = _sliced_to_array(useState(false), 2), isQuickAddModalOpen = _useState[0], setIsQuickAddModalOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), notAvailable = _useState1[0], setNotAvailable = _useState1[1];
    var context = useContext(TrackedLinkContext);
    var getItemQuantityInCart = useCartItems().getItemQuantityInCart;
    var _useCartUpdate = useCartUpdate(), updateCartItems = _useCartUpdate.updateCartItems, isQuickAddOptionLoading = _useCartUpdate.isPending;
    var cartProductAddOptions = useCartProductAddOptions();
    var addOptions = productAddOptions !== null && productAddOptions !== void 0 ? productAddOptions : cartProductAddOptions;
    var preventClickEvents = function(e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var onOpenModal = function(e) {
        preventClickEvents(e);
        onChooseOption === null || onChooseOption === void 0 ? void 0 : onChooseOption();
        trackEvent("/choose-options/".concat(productToken));
        if (context) {
            trackEvent("/container/".concat(context.containerName, "/choose-options/").concat(productToken));
        }
        setIsQuickAddModalOpen(true);
    };
    var onCloseModal = function() {
        setIsQuickAddModalOpen(false);
        onModalClose === null || onModalClose === void 0 ? void 0 : onModalClose();
    };
    var setAsUnavailable = function() {
        setNotAvailable(true);
        setTimeoutIfPossible(function() {
            return setNotAvailable(false);
        }, 2000);
    };
    var onQuickAdd = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var addedOptionToken, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        preventClickEvents(event);
                        if (!canAddToCart()) {
                            setAsUnavailable();
                            return [
                                2
                            ];
                        }
                        if (!quickAddData.quick_add_option) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            handleQuickAddOption()
                        ];
                    case 2:
                        addedOptionToken = _state.sent();
                        if (addedOptionToken) {
                            trackEvent("/quick-add/".concat(addedOptionToken));
                            if (context) {
                                trackEvent("/container/".concat(context.containerName, "/quick_add/").concat(addedOptionToken));
                            }
                        } else {
                            setAsUnavailable();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setAsUnavailable();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onQuickAdd(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleQuickAddOption = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _quickAddData_quick_add_option, option_token, _quickAddData_quick_add_option_option_unit_multiplier, option_unit_multiplier, _quickAddData_quick_add_option_option_min_order_quantity, option_min_order_quantity, option_available_units, cartUpdateStartTime, existingQuantity, newQuantity, addedItemData;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        logAssert(!!quickAddData.quick_add_option, "Undefined quick_add_option field on quick add to cart");
                        _quickAddData_quick_add_option = quickAddData.quick_add_option, option_token = _quickAddData_quick_add_option.option_token, _quickAddData_quick_add_option_option_unit_multiplier = _quickAddData_quick_add_option.option_unit_multiplier, option_unit_multiplier = _quickAddData_quick_add_option_option_unit_multiplier === void 0 ? 0 : _quickAddData_quick_add_option_option_unit_multiplier, _quickAddData_quick_add_option_option_min_order_quantity = _quickAddData_quick_add_option.option_min_order_quantity, option_min_order_quantity = _quickAddData_quick_add_option_option_min_order_quantity === void 0 ? 1 : _quickAddData_quick_add_option_option_min_order_quantity, option_available_units = _quickAddData_quick_add_option.option_available_units;
                        logAssert(!!option_token, "Undefined option token on quick add to cart");
                        cartUpdateStartTime = getWindowOrThrow().performance.now();
                        // Check that there is sufficient inventory for quantity already added + newly added quantity.
                        existingQuantity = getItemQuantityInCart(option_token);
                        newQuantity = Math.max(existingQuantity + option_unit_multiplier, option_min_order_quantity);
                        // option_available_units can be unset, this is to be interpreted as there are no limits.
                        if (option_available_units != null && newQuantity > option_available_units) {
                            return [
                                2
                            ];
                        }
                        onQuickAddOption === null || onQuickAddOption === void 0 ? void 0 : onQuickAddOption();
                        // Add to cart.
                        addedItemData = [
                            ICartItemForUpdate.build({
                                product_token: productToken,
                                brand_token: brandToken,
                                product_option_token: option_token,
                                quantity: newQuantity,
                                customizations: []
                            })
                        ];
                        return [
                            4,
                            updateCartItems({
                                items: addedItemData,
                                upltParams: {
                                    event: "add-to-cart",
                                    startTime: cartUpdateStartTime,
                                    variant: AddToCartVariants.QUICK_ADD_BTN
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            option_token
                        ];
                }
            });
        });
        return function handleQuickAddOption() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function() {
        return function(e) {
            if (isQuickAddOptionLoading) {
                return preventClickEvents(e);
            }
            if (quickAddData.quick_add_option && !forceShowModal) {
                return onQuickAdd(e);
            }
            return onOpenModal(e);
        };
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            productToken && isQuickAddModalOpen ? /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyQuickAddModal, {
                    onClose: onCloseModal,
                    productToken: productToken,
                    productAddOptions: addOptions,
                    updateCartFn: updateCartFn
                })
            }) : null,
            button ? button({
                shake: notAvailable,
                loading: isQuickAddOptionLoading,
                onClick: handleClick()
            }) : /*#__PURE__*/ _jsxs(QuickAddButton, {
                $shake: notAvailable,
                className: className,
                style: style,
                onClick: handleClick(),
                "data-test-id": "quick-add-marketplace-product",
                children: [
                    isQuickAddOptionLoading ? /*#__PURE__*/ _jsx(LoadingWrapper, {
                        children: /*#__PURE__*/ _jsx(LoadingSpinner, {
                            size: "small"
                        })
                    }) : null,
                    /*#__PURE__*/ _jsx(TextWrapper, {
                        $isLoading: isQuickAddOptionLoading,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            align: "center",
                            children: quickAddData.quick_add_text
                        })
                    })
                ]
            })
        ]
    });
};
var commonAddButtonCss = css([
    "position:absolute;left:50%;transform:translateX(-50%);overflow:hidden;background-color:",
    ";border:1px solid ",
    ";cursor:pointer;pointer-events:auto;",
    "{display:none;}",
    ";"
], Core.surface.inverse, Core.border.muted, responsiveMediaQueries.mobile, function(props) {
    return props.$shake ? ShakeAnimation("-50%") : "";
});
export var QuickAddButton = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-9e4fbd8f-0"
})([
    "width:calc(100% - 16px);min-height:30px;height:auto;",
    ";color:",
    ";text-align:center;",
    ""
], TypographyStyles({
    as: undefined
}), Core.text.default, commonAddButtonCss);
var TextWrapper = styled.div.withConfig({
    componentId: "sc-9e4fbd8f-1"
})([
    "",
    ";width:100%;"
], function(props) {
    return props.$isLoading ? css([
        "visibility:hidden;"
    ]) : "";
});
var LoadingWrapper = styled.div.withConfig({
    componentId: "sc-9e4fbd8f-2"
})([
    "position:absolute;width:100%;height:100%;display:flex;align-items:center;justify-content:center;"
]);
